import React, { useState } from 'react';
import { Button } from '@avangard/ui/core';

import { ChangePasswordFormModal } from '@modules/auth/organisms';

const ChangePasswordButton = (): React.ReactElement => {
    const [openChangePasswordFormModal, setChangePasswordFormModal] = useState<boolean>(false);

    const handleOpenChangePasswordFormModal = (): void => setChangePasswordFormModal(true);
    const handleCloseChangePasswordFormModal = (): void => setChangePasswordFormModal(false);

    return (
        <>
            <Button variant='outlined' onClick={handleOpenChangePasswordFormModal}>
                Сменить
            </Button>

            <ChangePasswordFormModal
                open={openChangePasswordFormModal}
                onClose={handleCloseChangePasswordFormModal}
            />
        </>
    );
};

export { ChangePasswordButton };
